import React, {useState} from "react";
import {Col} from "react-bootstrap";
import PropTypes from "prop-types";
import {GSPSIcon} from "Icons/GSPSIcon";
import Modal from "react-bootstrap/Modal";
import {Button} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import {makePatchRequest} from "Services/ServicesUtils";
import {insertNotification} from "Utils/NotificationsUtils";
import {API_AUDITS} from "Models/Audit/AuditEndpoints";

function getMediaIconName(mediaType) {
    if (mediaType === "image") {
        return "CardImage";
    }
    return "CameraVideo";
}
function getMediaViewer(mediaType, src, maxWidthPx, maxHeightPx, includeControls = false) {
    if (typeof src === "object") {
        src = URL.createObjectURL(src);
    }
    const style = {
        maxWidth: maxWidthPx + "px",
        maxHeight: maxHeightPx + "px",
        objectFit: "contain",
        marginBottom: "16px",
        padding: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: maxWidthPx + "px",
        height: maxHeightPx + "px",
        backgroundColor: "white",
        borderRadius: "5px",
        boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.2)",
        overflow: "hidden",
    };

    if (mediaType === "image") {
        return (
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
            }}>
                <img src={src} style={style} alt="Preview" />
            </div>
        );
    } else if (mediaType === "video") {
        return <video src={src} controls={includeControls} style={style}></video>;
    }
    console.warn(`Unknown Media type ${mediaType} received in MediaSelector component`);
    return <></>;
}

export const GSPSMediaSelector = ({
    controlSize,
    imageContainerSizePx,
    imageContainerHeightSizePx,
    notes,
    currentImageSrc,
    mediaType,
    media,
    elementType,
    onNotesSaved,
    isViewOnly = false,
}) => {
    const [isPreviewDisplayed, setIsPreviewDisplayed] = useState(false);
    const [mediaNotes, setMediaNotes] = useState(notes);

    const handleClose = () => setIsPreviewDisplayed(false);
    const handleShow = () => setIsPreviewDisplayed(true);

    const onHideSaveNotesOnCreate = mediaType === "video" && (media.id === undefined); // disable for video for now

    const onSaveNotes = () => {
        if (media.id === undefined) {
            onNotesSaved(mediaNotes);
            handleClose();
            return;
        }

        const body = {
            "notes": mediaNotes,
            "media_type": mediaType,
            "element_type": elementType, // issue, area, line
        };

        makePatchRequest(`${API_AUDITS.mediaData(media.id)}`, body)
            .then((jsonRes) => {
                insertNotification("Success",
                    `${mediaType} has been updated ..`,
                    "success");
                handleClose();
                onNotesSaved(mediaNotes);

                return jsonRes;
            }).catch((error) => {
                error.then((errorMessage) => {
                    const failureReason = JSON.stringify(errorMessage);
                    insertNotification("Error", `can't update ${failureReason}`, "error");
                });
            });
    };

    return <>
        <Col sm={controlSize} className="position-relative">
            <Modal className="modal show" id="exampleModal" role="dialog"
                backdrop="static"
                onHide={handleClose}
                show={isPreviewDisplayed}
                centered={true}
            >
                <Modal.Header closeButton={true}><h5>Preview</h5></Modal.Header>
                <Modal.Body>
                    {getMediaViewer(mediaType, currentImageSrc, 450, 280, true)}
                    {!onHideSaveNotesOnCreate &&
                        <div style={{display: "flex", justifyContent: "center", marginTop: "8px"}}>
                            <div style={{display: "flex", alignItems: "flex-end"}}>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <label style={{fontSize: "12px", marginBottom: "4px"}}>
                                        Notes:
                                    </label>
                                    <textarea
                                        value={mediaNotes}
                                        onChange={(e) => setMediaNotes(e.target.value)}
                                        placeholder="Enter notes..."
                                        style={{
                                            width: "250px",
                                            height: "32px",
                                            fontSize: "12px",
                                            padding: "4px",
                                            borderRadius: "4px",
                                            border: "1px solid #ccc",
                                        }}
                                    />
                                </div>
                                <Button
                                    className="cta-btn"
                                    onClick={onSaveNotes}
                                    variant={"outlined"}
                                    startIcon={<SaveIcon />}
                                    style={{
                                        marginLeft: "8px",
                                        height: "32px",
                                    }}
                                >
                                    Save
                                </Button>
                            </div>
                        </div>
                    }
                </Modal.Body>
            </Modal>
            <label
                style={{
                    width: imageContainerSizePx + "px",
                    height: imageContainerHeightSizePx + "px",
                    cursor: isViewOnly ? "default" : "pointer",
                }}
                onClick={handleShow}>
                {currentImageSrc &&
                    getMediaViewer(mediaType, currentImageSrc, imageContainerSizePx, imageContainerHeightSizePx)
                }
                {!currentImageSrc &&
                    <svg
                        xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                        className="bi bi-image" viewBox="0 0 16 16">
                        <GSPSIcon name={getMediaIconName(mediaType)} className="m-1" />
                    </svg>
                }
            </label>
        </Col>
    </>
    ;
};


GSPSMediaSelector.propTypes = {
    controlSize: PropTypes.number,
    imageContainerSizePx: PropTypes.number,
    imageContainerHeightSizePx: PropTypes.number,
    currentImageSrc: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    notes: PropTypes.string,
    mediaType: PropTypes.oneOf([
        "image",
        "video",
    ]),
    elementType: PropTypes.oneOf([
        "issue",
        "area",
        "line",
    ]),
    onNotesSaved: PropTypes.func,
    media: PropTypes.object,
    isViewOnly: PropTypes.bool,
};
